import {
  GET_CUSTOMER_INFORMATION_BEGIN, GET_CUSTOMER_INFORMATION_SUCCESS, GET_CUSTOMER_INFORMATION_FAILURE,
  POST_CUSTOMER_SOFT_BLOCK_BEGIN, POST_CUSTOMER_SOFT_BLOCK_SUCCESS, POST_CUSTOMER_SOFT_BLOCK_FAILURE,
  POST_CUSTOMER_UNBLOCK_BEGIN, POST_CUSTOMER_UNBLOCK_SUCCESS, POST_CUSTOMER_UNBLOCK_FAILURE,
  PUT_UPDATE_CUSTOMER_BEGIN, PUT_UPDATE_CUSTOMER_SUCCESS, PUT_UPDATE_CUSTOMER_FAILURE, CLEAR_UPDATE_CUSTOMER_DATA
} from '../constants/ActionTypes'

const initialState = {
  customerInfo: null,
  loadingCustomerInfo: false,
  errorCustomerInfo: null,

  loadingBlockCustomer: false,
  errorBlockCustomer: null,
  successBlockCustomer: null,

  loadingUnblockCustomer: false,
  errorUnblockCustomer: null,
  successUnblockCustomer: null,

  updatingCustomer: false,
  errorUpdateCustomer: null,
  successUpdateCustomer: null
}

// Reducer responsible for keeping Customer Information
// Customer Login / Address / Contact / Plaan / Orders / Subscriptions

const ReducerCustomer = (state = initialState, { type, payload }) => {
  switch (type) {

    //:: Get Customer Info
    case GET_CUSTOMER_INFORMATION_BEGIN: {
      return {
        ...state,
        loadingCustomerInfo: true,
        errorCustomerInfo: null,
      }
    }
    case GET_CUSTOMER_INFORMATION_SUCCESS: {
      return {
        ...state,
        customerInfo: payload,
        loadingCustomerInfo: false,
        errorCustomerInfo: null,
      }
    }
    case GET_CUSTOMER_INFORMATION_FAILURE: {
      return {
        ...state,
        loadingCustomerInfo: false,
        errorCustomerInfo: payload,
      }
    }

    //:: Update Customer
    case PUT_UPDATE_CUSTOMER_BEGIN: {
      return {
        ...state,
        updatingCustomer: true,
        errorUpdateCustomer: null,
        successUpdateCustomer: false
      }
    }
    case PUT_UPDATE_CUSTOMER_SUCCESS: {
      return {
        ...state,
        updatingCustomer: false,
        errorUpdateCustomer: null,
        successUpdateCustomer: true
      }
    }
    case PUT_UPDATE_CUSTOMER_FAILURE: {
      return {
        ...state,
        updatingCustomer: false,
        errorUpdateCustomer: payload,
        successUpdateCustomer: false
      }
    }

    //:: Block Customer
    case POST_CUSTOMER_SOFT_BLOCK_BEGIN: {
      return {
        ...state,
        loadingBlockCustomer: true,
        errorBlockCustomer: null,
        successBlockCustomer: false
      }
    }
    case POST_CUSTOMER_SOFT_BLOCK_SUCCESS: {
      return {
        ...state,
        loadingBlockCustomer: false,
        errorBlockCustomer: null,
        successBlockCustomer: true
      }
    }
    case POST_CUSTOMER_SOFT_BLOCK_FAILURE: {
      return {
        ...state,
        loadingBlockCustomer: false,
        errorBlockCustomer: payload,
        successBlockCustomer: false
      }
    }

    //:: Unblock Customer
    case POST_CUSTOMER_UNBLOCK_BEGIN: {
      return {
        ...state,
        loadingUnblockCustomer: true,
        errorUnblockCustomer: null,
        successUnblockCustomer: false
      }
    }
    case POST_CUSTOMER_UNBLOCK_SUCCESS: {
      return {
        ...state,
        loadingUnblockCustomer: false,
        errorUnblockCustomer: null,
        successUnblockCustomer: true
      }
    }
    case POST_CUSTOMER_UNBLOCK_FAILURE: {
      return {
        ...state,
        loadingUnblockCustomer: false,
        errorUnblockCustomer: payload,
        successUnblockCustomer: false
      }
    }

    case CLEAR_UPDATE_CUSTOMER_DATA: {
      return {
        ...state,
        updatingCustomer: false,
        errorUpdateCustomer: false,
        successUpdateCustomer: false
      }
    }

    default: return state
  }
}

export default ReducerCustomer
